export const getFileType = (url: string): string => {
  if (!url) return 'unknown';
  
  const extension = url.split('.').pop()?.toLowerCase();
  
  switch (extension) {
    case 'pdf':
      return 'pdf';
    case 'mp4':
    case 'avi':
    case 'mov':
    case 'wmv':
    case 'flv':
    case 'webm':
    case 'mkv':
      return 'video';
    case 'mp3':
    case 'wav':
    case 'ogg':
    case 'aac':
    case 'flac':
    case 'm4a':
      return 'audio';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'webp':
    case 'svg':
      return 'image';
    case 'txt':
    case 'html':
    case 'htm':
      return 'text';
    default:
      return 'unknown';
  }
};

export const getContentTypeFromUrl = (url: string): string => {
  // URL에서 content-type을 추출하는 로직 (필요시 구현)
  // 예: URL에 content-type 파라미터가 있는 경우
  try {
    const urlObj = new URL(url);
    const contentType = urlObj.searchParams.get('content-type');
    if (contentType) {
      if (contentType.includes('pdf')) return 'pdf';
      if (contentType.includes('video')) return 'video';
      if (contentType.includes('audio')) return 'audio';
      if (contentType.includes('image')) return 'image';
      if (contentType.includes('text')) return 'text';
    }
  } catch (e) {
    // URL 파싱 실패시 파일 확장자로 판단
  }
  
  return getFileType(url);
};
